import { Box, Card, Divider, makeStyles, Typography } from "@material-ui/core";
import React from "react";

import CashIcon from "../../../../assets/icons/paymentIcon/Cash.png";
import CardIcon from "../../../../assets/icons/paymentIcon/Card.png";
import TransferIcon from "../../../../assets/icons/paymentIcon/Transfer.png";
import SplitPaymentIcon from "../../../../assets/icons/paymentIcon/disabledIcon/Split.png";
import useStatTotalTrans from "../../../../hooks/useStatTotalTrans";
import { useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
  textHeaderStyle: {
    fontSize: "20px",
    fontWeight: "bold",
    color: theme.blue,
    marginTop: 6,
  },
  icon: {
    margin: "0px 10px",
    width: "20px",
    height: "20px",
    objectFit: "contain",
  },
  card: {
    height: 125,
    width: 357,
    boxShadow: "0px 10px 0px -7px rgba(0,0,0,0)",
    borderRadius: 8,
    marginTop: 6,
  },
  paymentElementsContainer: {
    display: "block",
    justifyContent: "space-evenly",
  },
  dispalyFlexTextAndIcon: {
    display: "flex",
    justifyContent: "space-between",
    margin: "10px 11px",
    // height: 50,
  },
  flexBox: {
    display: "flex",
  },
}));

function PaymentComponent({ periodType, fromDate, toDate }) {
  const classes = useStyles();
  const translate = useTranslate();
  const { totalTrans, loading, error } = useStatTotalTrans(
    periodType,
    fromDate,
    toDate
  );
  if (loading) return null;
  if (error) return null;

  const handleSum = (paymentType) => {
    let tempList = [];
    totalTrans?.total_trans?.forEach((element) => {
      if (!element.segment.paymentMethod || !element || !element.segment) {
        return;
      }
      const cash = Object.values(element.segment.paymentMethod).find(
        (value) => value.name === paymentType
      );
      tempList.push(cash);
    });

    return {
      name: paymentType,
      value: tempList.reduce((a, b) => a + b.value, 0),
    };
  };

  let cash = handleSum("Cash");
  let card = handleSum("Credit / Debit Card");
  let transfer = handleSum("Transfer");
  // let split = handleSum("Split Payment");
  let tempPaymentMethod = [];
  let paymentMethod = [];

  tempPaymentMethod.push(transfer);
  tempPaymentMethod.push(cash);
  tempPaymentMethod.push(card);

  const sortedPayments = tempPaymentMethod.sort(function (a, b) {
    return b.value - a.value;
  });

  sortedPayments.forEach((element) => {
    paymentMethod.push({
      name: element.name,
      value: element.value,
      icon:
        element.name === "Cash"
          ? CashIcon
          : element.name === "Credit / Debit Card })"
          ? CardIcon
          : element.name === "Transfer"
          ? TransferIcon
          : SplitPaymentIcon,
    });
  });

  return (
    <Box>
      <Typography className={classes.textHeaderStyle}>
        {translate("ra.text.bi.payments")}
      </Typography>
      <Card className={classes.card}>
        {paymentMethod.map((eachData, index) => (
          <Box key={index} className={classes.paymentElementsContainer}>
            <Box className={classes.dispalyFlexTextAndIcon} marginLeft="11px">
              <Box className={classes.flexBox}>
                <Typography style={{ fontSize: "14px" }}>
                  {index + 1}
                </Typography>
                <img className={classes.icon} src={eachData.icon} alt="?" />
                <Typography style={{ fontSize: "14px" }}>
                  {eachData.name}
                </Typography>
              </Box>
              <Box className={classes.flexBox}>
                <Typography
                  style={{ fontSize: "14px" }}
                >{`${eachData.value.toLocaleString()} ${translate(
                  "ra.text.bi.transactions"
                )}  `}</Typography>
                {/* <Typography>{"Transactions"}</Typography> */}
              </Box>
            </Box>
            {index === 3 ? <Box /> : <Divider />}
          </Box>
        ))}
      </Card>
    </Box>
  );
}

export default PaymentComponent;
